import { useLayoutEffect } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import classes from './OuterContainer.module.css';
import { Header } from 'shared-front-end';
import { DisplayToast } from 'gossamer-front-end';

export const OuterContainer = () => {
  return (
    <div className={classes.OuterContainer}>
      <Header />
      <div className="scroll">
        <Outlet />
        <footer className={classes.Footer}>
          <div className="d-flex flex-wrap gap-3 justify-content-between small text-muted">
            <span>© {new Date().getFullYear()} Careerbook</span>
            <span>
              <Link to="/website/attendee-booking-cancellation-refund-terms">Booking, Cancellation & Refund Terms</Link>{' '}
              · <Link to="/website/host-payments-payout-terms">Host Payments & Payout Terms</Link> ·{' '}
              <Link to="/website/privacy-policy">Privacy</Link> ·{' '}
              <Link to="/website/platform-terms">Platform Terms</Link> ·{' '}
              <Link to="/website/trust-centre">Trust Centre</Link>
            </span>
          </div>
        </footer>
        <DisplayToast />
      </div>
    </div>
  );
};

export const ScrollToTop = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    // Scroll to the top of the page when the route changes
    document.querySelector('.scroll')?.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [location.pathname]);

  return children;
};
